<template>
  <!-- 工作台——项目看板 -->
  <div class="workProjectBoard">
    <!-- 左侧，我的项目 -->
    <div class="myProjects">
      <myProjects ref="myProjects" :current-prj-id="currentPrjId" @setCurrentProject="setCurrentProject">
      </myProjects>
    </div>

    <!-- 右侧，项目内容 -->
    <div class="projectContent">
      <div class="top">
        <!-- 项目进度 -->
        <div class="projectProcess">
          <projectProcess :current-prj-id="currentPrjId" :current-project="currentProject"
            @enterProjectFront="enterProjectFront"></projectProcess>
        </div>
        <!-- 项目概况 -->
        <div class="projectOverview">
          <projectOverview :current-prj-id="currentPrjId"></projectOverview>
        </div>
      </div>

      <div class="down">
        <!-- 项目公告 -->
        <div class="projectNotice">
          <projectNotice :current-prj-id="currentPrjId" @enterProjectFront="enterProjectFront"></projectNotice>
        </div>
        <!-- 待审 -->
        <div class="waitApproval">
          <waitApproval :current-prj-id="currentPrjId" @enterProjectFront="enterProjectFront"></waitApproval>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import myProjects from "./components/myProjects.vue";
import projectProcess from "./components/projectProcess.vue";
import projectNotice from "./components/projectNotice.vue";
import projectOverview from "./components/projectOverview.vue";
import waitApproval from "./components/waitApproval.vue";
import workProjectBoardService from "@/CommonDP/service/workProjectBoard-service";
export default {
  name: "WorkProjectBoard",
  components: { myProjects, projectProcess, projectNotice, projectOverview, waitApproval },
  data() {
    return {
      myProjects: [], // 我的项目
      currentPrjId: "", // 当前项目id
      currentProject: {} // 当前项目
    };
  },
  computed: {
    ...mapState({
      workBoardPrjId: state => state.enterprise.workBoardPrjId,
      enterpriseId: state => state.enterprise.enterpriseId
    })
  },
  watch: {
    workBoardPrjId(val) {
      if (val) {
        this.currentPrjId = val;
      }
    }
  },
  async mounted() {
    await this.getMyProjects();
    // 当前用户拥有此项目权限，有效则赋给当前id值
    this.myProjects.forEach(item => {
      if (item.prjId === this.workBoardPrjId) {
        this.currentPrjId = this.workBoardPrjId;
        this.currentProject = item;
      }
    });
    if (!this.currentPrjId && this.myProjects.length > 0) {
      this.currentPrjId = this.myProjects[0].prjId;
      this.currentProject = this.myProjects[0];
    }
  },
  methods: {
    // 获得我的项目
    async getMyProjects() {
      const res = await workProjectBoardService.getMyProjects(this.enterpriseId);
      this.myProjects = res.data;
      this.$refs.myProjects.setMyProjects(this.myProjects || []);
    },
    // 设置当前项目
    setCurrentProject(project) {
      this.$store.dispatch("setWorkBoardPrjId", project.prjId);
      this.currentPrjId = project.prjId;
      this.currentProject = project;
    },
    // 进入项目前置条件
    async enterProjectFront() {
      this.$store.dispatch("updatePrj", this.currentProject);
    }
  }
};
</script>

<style lang='scss' scoped>
.workProjectBoard {
  width: 100%;
  height: 100%;
  background: #eff1f6;
  display: flex;

  .myProjects {
    width: 280px;
    height: 100%;
    background: #ffffff;
    border-radius: 4px;
    margin-right: var(--middle-space);
  }

  .projectContent {
    width: calc(100% - 280px - var(--middle-space));
    min-width: 900px;
    height: 100%;

    .top {
      width: 100%;
      height: 50%;
      margin-bottom: var(--middle-space);
      display: flex;

      .projectProcess {
        width: 65%;
        height: 100%;
        background: #ffffff;
        border-radius: 4px;
        margin-right: var(--middle-space);
      }

      .projectOverview {
        width: calc(35% - var(--middle-space));
        height: 100%;
        background: #ffffff;
        border-radius: 4px;
      }
    }

    .down {
      width: 100%;
      height: calc(50% - var(--middle-space));
      display: flex;

      .projectNotice {
        width: 65%;
        height: 100%;
        background: #ffffff;
        border-radius: 4px;
        margin-right: var(--middle-space);
      }

      .waitApproval {
        width: calc(35% - var(--middle-space));
        height: 100%;
        background: #ffffff;
        border-radius: 4px;
      }
    }
  }
}
</style>
